import { render, staticRenderFns } from "./ScrapAuthorizationsForm.vue?vue&type=template&id=f2ba1812"
import script from "./ScrapAuthorizationsForm.vue?vue&type=script&lang=js"
export * from "./ScrapAuthorizationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports